// extracted by mini-css-extract-plugin
export var apply = "MobileSectionModal-module--apply--b0805";
export var blockWrapper = "MobileSectionModal-module--blockWrapper--77116";
export var content = "MobileSectionModal-module--content--8440b";
export var fadeInAnimation = "MobileSectionModal-module--fadeInAnimation--88e2e";
export var title = "MobileSectionModal-module--title--8ba23";
export var titleText = "MobileSectionModal-module--titleText--f6cda";